import styled from 'styled-components';
import { StyledMyAuditContainer } from '../../../common/sharedStyledComponents/MyAuditGenericStyles.styled';

export const DepartmentHeaderContainer = styled.div`
  align-items: baseline;
  display: flex;
  justify-content: space-between;
`;

export const FilterHeaderContainer = styled.div`
  align-items: baseline;
  display: flex;
  margin: ${({ theme }) => theme.spacing.l} 0 ${({ theme }) => theme.spacing.xm}
    0;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.m};

  & span {
    background-color: transparent !important;

    &:before {
      background-color: ${({ theme }) => theme.colors.verdigris};
      width: 12px;
      height: 12px;
    }
  }

  & .control-radio-overflow INPUT {
    display: none;
  }
`;

export const LabelContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.s};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.m};
`;

export const ButtonsContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.s};
`;

export const SearchFieldContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.m};
`;

export const ControlSelectContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.l};
`;

export const LineHeader = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.oxfordBlue};
`;

export const StyledMyAuditQuestionnaireContainer = styled(
  StyledMyAuditContainer
)`
  margin-top: 162px;
  margin-bottom: 170px;
`;

export const InformationFloatingContainer = styled.div`
  position: fixed;
  right: 16px;
  bottom: 110px;
  display: flex;
  align-items: center;
  z-index: 900;
`;

export const InformationFloatingContent = styled.button`
  background-color: ${({ theme }) => theme.colors.oxfordBlue};
  padding: 3px 10px;
  margin-right: -3px;
  border: none;
`;

export const CircleInfo = styled.button`
  background-color: ${({ theme }) => theme.colors.oxfordBlue};
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
`;

export const InformationList = styled.ol`
  padding-left: ${({ theme }) => theme.spacing.m};
`;

export const InformationItem = styled.li`
  padding-left: ${({ theme }) => theme.spacing.s};
  padding-bottom: ${({ theme }) => theme.spacing.s};
  padding-top: ${({ theme }) => theme.spacing.s};
`;

export const RomanList = styled.ol``;

export const RomanItem = styled.li`
  list-style-type: upper-roman;
`;

export const ImgMyLQAList = styled.div`
  height: 200px;
`;

export const ImgAddSection = styled.div`
  height: 200px;
`;

export const ImgAddSectionSave = styled.div`
  height: 200px;
`;

export const ImgAddNew = styled.div`
  height: 50px;
`;

export const ImgQuestionButtons = styled.div`
  height: 50px;
`;

export const ImgQuestionList = styled.div`
  height: 90px;
`;

export const ImgSaveAndPublish = styled.div`
  height: 45px;
`;

export const ImgModalInfo = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;
